import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import { SessionStatus } from '@app/api';
import { useTranslation } from 'react-i18next';
import { mapValues } from 'lodash';

export const statusColors: Record<SessionStatus, Colors> = {
  [SessionStatus.DRAFT]: 'inkSecondary',
  [SessionStatus.LIVE]: 'blue',
  [SessionStatus.FULL]: 'green',
  [SessionStatus.PAUSED]: 'red',
  [SessionStatus.CLOSED]: 'accent',
};

const useStyles = createUseStyles((theme: Theme) => ({
  status: {
    ...theme.fonts.label,
    padding: `2px ${theme.marginBase}px`,
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.grayBackground,
    color: theme.colors.inkSecondary,
  },
}));

export const useSessionStatusStyles = createUseStyles((theme: Theme) => {
  return mapValues(
    statusColors,
    (color) => theme.mutedColorCombinations[color],
  );
});

interface Props {
  status?: SessionStatus;
  className?: string;
}

export const StatusLabel = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const statusClasses = useSessionStatusStyles({ theme });
  const { t, i18n } = useTranslation();

  if (!props.status) {
    return null;
  }

  return (
    <div
      className={classnames(
        classes.status,
        statusClasses[props.status],
        props.className,
      )}
    >
      {i18n.exists(`sessions.status.${props.status}`)
        ? t(`sessions.status.${props.status}`)
        : props.status}
    </div>
  );
};
